var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main container" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12 text-center" }, [
        _c("h4", { staticClass: "highlight-color" }, [
          _vm._v(_vm._s(_vm.$t("message.resetpassword")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "highlight-color" }, [
          _vm._v(_vm._s(_vm.$t("message.intro1")))
        ])
      ]),
      _vm._v(" "),
      _vm.is_valid_token && !_vm.reset_password_success
        ? [
            _c("div", { staticClass: "col-md-6 form" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("message.newpassword")))]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.password,
                      expression: "form.password"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    disabled: _vm.$store.state.app.loading == true,
                    type: "password"
                  },
                  domProps: { value: _vm.form.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "password", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("message.confirmpassword")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.confirm_password,
                      expression: "form.confirm_password"
                    }
                  ],
                  staticClass: "form-control",
                  class: [
                    {
                      "is-invalid":
                        !_vm.isMatchedPassword &&
                        _vm.form.password.length > 0 &&
                        _vm.form.confirm_password.length > 0
                    }
                  ],
                  attrs: {
                    disabled: _vm.$store.state.app.loading == true,
                    type: "password"
                  },
                  domProps: { value: _vm.form.confirm_password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.form,
                        "confirm_password",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "invalid-feedback" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.passworddoesnotmatch")) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-web btn-block",
                  attrs: {
                    disabled: _vm.disabledResetPassword,
                    type: "submit"
                  },
                  on: {
                    click: function($event) {
                      return _vm.resetPassword()
                    }
                  }
                },
                [
                  _vm.$store.state.app.loading
                    ? _c("span", [
                        _c("i", { staticClass: "fas fa-spinner spin" })
                      ])
                    : _c("span", [_vm._v(_vm._s(_vm.$t("button.confirm")))])
                ]
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.is_valid_token && _vm.reset_password_success
        ? [
            _c("div", { staticClass: "col-md-6 form" }, [
              _c("p", { staticClass: "m-0 text-center text-success" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.resetpasswordsuccess")) +
                    " "
                ),
                _c("i", { staticClass: "far fa-check-circle" })
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.is_valid_token
        ? [
            _c("div", { staticClass: "col-md-6 form" }, [
              _c("p", { staticClass: "m-0 text-center text-danger" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.tokenwasexpired")) + " "
                ),
                _c("i", { staticClass: "fas fa-exclamation" })
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "m-0", staticStyle: { "font-size": "13px" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("message.notetokenexpired")) +
                      "\n      "
                  )
                ]
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.is_valid_token || _vm.reset_password_success
        ? _c("div", { staticClass: "col-md-12 text-center" }, [
            _c(
              "p",
              { staticClass: "text-white mb-1" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "text-white",
                    attrs: {
                      to: {
                        name: "SignIn"
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.login")) +
                        "\n      "
                    )
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo col-md-12 text-center" }, [
      _c("img", { attrs: { src: require("./../../assets/logo-10.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dbea0a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dbea0a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/ResetPassword.vue
// module id = null
// module chunks = 